import { render, staticRenderFns } from "./ios.vue?vue&type=template&id=157050bd&scoped=true"
import script from "./ios.vue?vue&type=script&lang=js"
export * from "./ios.vue?vue&type=script&lang=js"
import style0 from "./ios.vue?vue&type=style&index=0&id=157050bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157050bd",
  null
  
)

export default component.exports